import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fgbcl-card-link-external-url-modal',
  templateUrl: './card-link-external-url-modal.component.html',
  styleUrls: ['./card-link-external-url-modal.component.scss'],
})
export class CardLinkExternalUrlModalComponent implements OnInit {
  @Input() companyImageUrl: string;
  @Input() clubImageUrl: string;
  @Input() navigationUrl: string;
  @Input() offerDescription: string;
  constructor() {}
  ngOnInit(): void {}
}
